// extracted by css-extract-rspack-plugin
export default {"pageLayout":"src-app-pages-electronic-preparation-Meeting-Meeting-module__pageLayout-J9sXIc","headerTable":"src-app-pages-electronic-preparation-Meeting-Meeting-module__headerTable-Upw_yI","bodyTable":"src-app-pages-electronic-preparation-Meeting-Meeting-module__bodyTable-cyKX5y"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"pageLayout\":\"src-app-pages-electronic-preparation-Meeting-Meeting-module__pageLayout-J9sXIc\",\"headerTable\":\"src-app-pages-electronic-preparation-Meeting-Meeting-module__headerTable-Upw_yI\",\"bodyTable\":\"src-app-pages-electronic-preparation-Meeting-Meeting-module__bodyTable-cyKX5y\"}";
        // 1789362522829
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  